<template>
  <div class="pa-0 ma-0" style="min-height: 100vh !important">
    <v-carousel
      class="pa-0 ma-0"
      continuous
      progress
      hide-delimiters
      :show-arrows="false"
      :interval="interval"
      height="100vh"
    >
      <!-- <hbt-navbar :endtime="endtime" /> -->
      <v-carousel-item
        v-for="(c,i) in capas" :key="i"
        class="pa-0 ma-0"
        style="height: 100vh !important"
        @click="$vuetify.goTo('#atalhos')"
      >
        <!-- <v-parallax 
          dark
          class="px-0 mx-0"
          v-bind="heightParallax"
          style="height: 500px !important; cursor: pointer"
          :src="getImg(c.imagem_horiz)"
        > -->
        <v-parallax 
          dark
          class="pa-0 ma-0"
          v-bind="heightParallax"
          style="height: 100% !important; cursor: pointer"
          :src="getImg(c.imagem)"
        >
          <div style="
            background-color: rgba(0, 0, 0, 0.5);
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
          "></div>
          <!-- <v-hover>
            <template v-slot:default="{ hover }"> -->
              
              <!-- <nuxt-link :to="{name: 'id', params: {id: c.url}}"> -->
                <v-container style="position: relative;">
                  <v-row 
                    class="justify-center" 
                  >
                    <v-col cols="12" md="9"
                      class="px-4 text-center"
                    >
                      <!-- <div class="font-weight-medium white--text text--darken-2 body-2">
                        <span class="primary--text text-uppercase">Terça-feira, 3/mar</span>
                      </div> -->
                      <h1 
                        class="white--text font-weight-medium pt-2 display-4 text-uppercase">
                        <span class="barlow" v-html="c.titulo"></span>
                      </h1>
                      <div class="font-weight-regular white--text pt-2 headline">
                        <!-- <span class="lato" v-html="c.subtitulo">Oferecemos treinamento para melhorar o desempenho e garantia de integridade na gestão dos recursos públicos.</span> -->
                        <span class="open-sans">{{c.subtitulo}}</span>
                      </div>
                      <div class="font-weight-medium grey--text text--lighten-2 body-2 pt-12">
                        <span class="text-uppercase pb-1">{{c.cta}}</span>
                      </div>
                      <div style="bottom: 0 !important;">
                        <v-icon>mdi-chevron-down</v-icon>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              <!-- </nuxt-link> -->
                
            <!-- </template> -->
          <!-- </v-hover> -->
        </v-parallax>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<style >
/* .heightParallax{
  height: 100%
} */
  
</style>

<script>
//  import HbtNavbar from '@/components/Navbar';

export default {
  components: {
    // HbtNavbar,
  },
  data: () => ({
    //id: this.$route.params.id,
    logo: 'logo.png',
    paral: 'height',
    interval: 6000,
    capas: [
      {
        imagem: 'capa.jpg',
        titulo: '<span class="primary--text">Potencial</span> <span class="white--text">Humano</span>',
        subtitulo: 'Quebre seus bloqueios, desperte seus poderes e descubra o impacto de uma Vida Plena.',
        cta: 'saiba como'
      }
    ]
  }),
  computed: {
    heightParallax () {
      if (this.$vuetify.breakpoint.smAndDown) {
        return { height: '100%' }
      }
      else{
        return null
      }
    }
  },
  methods: {
    getImg(i) {
      return require('@/assets/img/'+i)
    },
  }
};
</script>